export default status => {
  if (status === 'SUCCEEDED') {
    return '#ececff';
  } if (status === 'PENDING') {
    return '#e2e2e2';
  } if (status === 'FAILED') {
    return '#ffe0b1';
  } return '#e2e2e2';
};
